<template>
    <!-- topic browse displays -->
    <div>
      <!--  <template v-for="(chip, i) of selectedAuthors" >-->
            <!-- {{chip}} -->
      <!--        <span class="chip" :key="i">{{chip}}-->
      <!--            <font-awesome-icon icon="times-circle" v-on:click="selectedAuthors = selectedAuthors.filter(x => x != chip)" />-->
      <!--        </span>-->
      <!--</template>-->
      <!--<template v-for="(chip, i) of selectedTopics" >-->
          <!-- {{chip}} -->
      <!--      <span class="chip" :key="i">{{chip}}-->
      <!--          <font-awesome-icon icon="times-circle" v-on:click="selectedTopics = selectedTopics.filter(x => x != chip)" />-->
      <!--      </span>-->
      <!--  </template>-->
    <input type="text" v-model.trim.lazy="keyword" placeholder="Search title"/>
    {{noOfPublications}} Publications <hr/>
    <Paginate v-if="getPages().length > 1"  :noofpages="getPages()" :page="page" v-on:goto="pageSelect" :noperpage="noPerPage" :showrecordscount="false" :maxofrecords="noOfPublications"></Paginate>
    <!--<ul class='result'>-->
    <!--  <font-awesome-icon icon="table" :class="listMode ? 'disabled' : ''" v-on:click="listMode = false"></font-awesome-icon>-->
    <!--  &nbsp; -->
    <!--  <font-awesome-icon icon="list" :class="listMode ? '' : 'disabled'"  v-on:click="listMode = true"></font-awesome-icon>-->
    <!--</ul>-->
    <tableList :publications='publications' v-if="!listMode"></tableList>
    <recordList :publications='publications' v-if="listMode"></recordList>
  </div>
  
    <!-- End of topic browse displays -->
</template>

<script>
  // @ is an alias to /src
  // import fetchJsonp from 'fetch-jsonp'
  import Vue from 'vue'
  import ChineseTranslator from '../assets/chineseTranslator'
  import TextHighlight from 'vue-text-highlight'
  import Paginate from '../components/Paginate'
  import range from 'lodash.range'
  
  import recordList from '@/components/recordList.vue'
  import tableList from '@/components/tableList.vue'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faTimesCircle)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

const TITLE = 'title_text_cjk'
const AUTHOR = 'author-editor-or-organization_ss'
const YEAR = 'year-derived_s'
const PUBLISHER = 'publisher_s'
const VOLUME = 'volume_s'
const PLACE = 'place-of-publication_s'
const PERIOD = 'series_s'
const REF_TYPE = 'reference-type_s'
const PAGE = 'page-range_s'


Vue.config.productionTip = false
  // const Cite = require('citation-js')
  // require('@citation-js/plugin-bibjson')
  Vue.component('text-highlight', TextHighlight)

  // const normalize = function(str) {
  //   return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[.,/#!$%^&*;:{}=\-_`~()ʻ"“]/g,"").toUpperCase()
  // }

  export default {
    name: 'topics',
    data: function () {
      return {
        listMode: false,
        keyword: "",
        // publications: [],
        pages: {},
        page: 0,
        noPerPage: 20,
        // noOfResults: "",
        author: "",
        filteredAuthors: [],
        // selectedTopics: [],
        // selectedAuthors: []
        // unfolded: {}
      }
    },
    components: {
      Paginate,
      recordList,
      tableList
    },
    created: function () {
      this.$store.dispatch('setPage', 0)
      this.search("*:*")      
      // this.$store.dispatch('fetchPublications')   
    },
    updated: function () {
      // eval('generateCitation()')
      this.generateCitation()
    },
    beforeMount: function() {
      this.keyword = ""
      // this.selectedTopics = this.$store.getters.getSelectedTopics
      // this.selectedAuthors = this.$store.getters.getSelectedAuthors
    },
    computed: {
      publications () {
        return this.$store.state.publications
      },
      noOfPublications () {
        return this.$store.getters.getNoOfPublications
      },
      selectedTopics () {
        return this.$store.getters.getSelectedTopics
      },
      selectedAuthors () {
        return this.$store.getters.getSelectedAuthors
      }
    },
    mounted: function () {
    // `this` points to the vm instance
      console.log(this.$route.params)
                this.keyword = this.$route.params.keyword || ''
    },
    watch: {
      keyword: function (val) {
      //   console.log(val)
      //   console.log(ChineseTranslator.toTraditional(val))
      //   console.log(ChineseTranslator.toSimplified(val))
        if (val.length > 0) {
          let terms = [val]
          let sims = ChineseTranslator.toSimplified(val)
          let trads = ChineseTranslator.toTraditional(val)

          if (terms.indexOf(sims) == -1) (
            terms.push(sims)
          )
          if (terms.indexOf(trads) == -1) (
            terms.push(trads)
          )

          if (terms.length > 1) {
            terms = terms.map(x => `(${x})`)
          }
          
          this.search(`(all_txt_cjk:(${terms.join('')}))`)
        } else {
          this.search("*:*")
        }
      },
      selectedTopics: function(val) {
        this.$store.dispatch('selectedTopics', val)
        this.$store.dispatch('fetchPublications')  
      },
      selectedAuthors: function(val) {
        this.$store.dispatch('selectedAuthors', val)
        this.$store.dispatch('fetchPublications')  
      },
    },
    methods: {
      cslJson (pub) {
        // console.log(pub)
        let _item = pub
        let type = "";
      
      switch(_item[REF_TYPE]){
        case "Audio or Video Document":
           type= "article";
           break;
        case "Book":
           type= "book";
           break;
        case "Book, Edited":
           type= "book";
           break;
        case "Collected Work":
           type= "article";
           break;
        case "Conference Proceedings":
           type= "paper-conference";
           break;
        case "Contribution in…":
           type= "article";
           break;
        case "Internet Document":
           type= "webpage";
           break;
        case "Journal Article":
           type= "article-journal";
           break;
        case "Lecture":
           type= "article";
           break;
        case "Manuscript":
           type= "manuscript";
           break;
        case "Movie":
           type= "motion_picture";
           break;
        case "Musical Work / Music Album":
           type= "song";
           break;
        case "Report or Gray Literature":
           type= "article";
           break;
        case "Special Issue":
           type= "article";
           break;
        case "Thesis":
           type= "thesis";
           break;
      }
      
      // console.log(pub)
      
      var result = {
    type: type || '',
    title: _item[TITLE],
    author:[],
//     author: [
//       {
// 	given: "H. K.",
// 	family: "Hall"
//       }
//     ],
    issued: { 'raw': _item[YEAR] || '' } ,
    // issued: [],
    // containerTitle: _item.Series,
    // edition:_item.Edition || '',
    // ISBN: _item.ISBN || '',
    publisher: _item[PUBLISHER] ? _item[PUBLISHER] : '',
    issue:_item.Number|| '',
    volume: _item[VOLUME]|| '',
    page: _item[PAGE]|| '',
  }
  result['container-title']=_item[PERIOD] || '';
  result['publisher-place']=_item[PLACE] || '';

  _item[AUTHOR].reduce((acc, name)=>{
    let name_components = name.split(',')
    acc.push({
      family: name_components[0],
      given: name_components[1] || ''
    })
    return acc
  },
  result['author']
  )

  // for (let i=0; i < _item.author-editor-or-organization_ss.length; i++){
  //   let name_components = _item.author-editor-or-organization_ss[i].split(',');
    
  //   result['author'].push({
  //     family: name_components[0],
  //     given: name_components[1] || ''
  //   })
  // }
//   for (var i=0; i < _item.Year_indexed.length; i++){
//     var obj = {raw:_item.Year_derived};
//     result.issued.push({
// 	"date-parts": [ "1957", "1", "1" ]
//       });
//   }
  
  // console.log(result);
      return JSON.stringify(result);
      },
      generateCitation: function() {
        window.generateCitation()
      },
      search: function(keyword) {
        // console.log(keyword)
        this.$store.dispatch('setKeyword', keyword)
        this.$store.dispatch('fetchPublications')  
      //   let response = await fetchJsonp(`https://crossasia.org/solr/ext-IKGF/select?q=${keyword}&start=${this.page}&rows=15&&wt=json`, {
      //   jsonpCallback: 'json.wrf',
      // })
      // let data = await response.json()
      // this.noOfResults = data.response.numFound
      // this.publications = data.response.docs

      },
      getPages: function() {
        let totalPage = Math.floor(this.noOfPublications / this.noPerPage + (this.noOfPublications % this.noPerPage == 0 ? 0 :1));
        
        if (totalPage < 12){
          return range(0,totalPage);
        } else {
          let start = Math.max(0, this.page-5);
          let end = Math.min(start + 11, totalPage)
          if (start + 11 >  totalPage){
            end = totalPage;
            start = Math.max(0, end-11);
          }
          
          return range(start, end)
         
        }
      },
      pageSelect: function(val) {
        this.page = val      
        this.$store.dispatch('setPage', val)
        this.$store.dispatch('fetchPublications')  
      },
      hightLightExpands: function(terms) {
        let termsCleaned = terms.map(x => x.replace(/"/gm, ''))        
        termsCleaned = termsCleaned.reduce((acc,term)=>{
          let sims = ChineseTranslator.toSimplified(term)
          let trads = ChineseTranslator.toTraditional(term)
          if (acc.indexOf(sims) == -1) {
            acc.push(sims)
          }
          if (acc.indexOf(trads) == -1) {
            acc.push(trads)
          }
          return acc
        },termsCleaned)
        // console.log(termsCleaned)
        return termsCleaned
      }
    }
  }
</script>
<style scoped>
  .disabled {
    opacity: 0.5;
  }
</style>
